import { render, staticRenderFns } from "./PartsManagementTable.vue?vue&type=template&id=4e877738"
import script from "./PartsManagementTable.vue?vue&type=script&lang=js"
export * from "./PartsManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports